import React, { ReactElement, useState, useEffect } from 'react';
import classNames from 'classnames';
import Icon from 'atomic/icon';
import Circle from 'atomic/circle/circle';

import './carousel-multi-button-group.scss';

const SLIDE_INDICATOR_WIDTH = 124;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CarouselMultiButtonGroup = ({ next, previous, isSlideIndicator, ...rest }: any): ReactElement => {
    const { carouselState: { currentSlide, totalItems, slidesToShow } } = rest;
    const [slideIndicatorRangeWidth, setSlideIndicatorRangeWidth] = useState(0);
    const [slideIndicatorRangePosition, setSlideIndicatorRangePosition] = useState(0);

    useEffect(() => {
        if (isSlideIndicator) {
            setSlideIndicatorRangeWidth(SLIDE_INDICATOR_WIDTH / Math.ceil(totalItems / slidesToShow));
        }
    }, [isSlideIndicator, totalItems, slidesToShow]);

    useEffect(() => {
        if (isSlideIndicator) {
            setSlideIndicatorRangePosition(Math.floor(currentSlide / slidesToShow) * slideIndicatorRangeWidth);
        }
    }, [currentSlide, isSlideIndicator, slidesToShow, slideIndicatorRangeWidth]);

    return (
        <div
            className={classNames('carousel-button-group', {
                ['carousel-button-group--slide-indicator']: isSlideIndicator
            })}
        >
            {currentSlide !== 0 && (
                <Circle
                    ariaLabel="Poprzednia strona"
                    onClick={previous}
                    tag="button"
                    color="secondary"
                    background="white"
                    border="secondary"
                    className="carousel-button-group-prev"
                >
                    <Icon name="arrow-left" color="secondary" size={18} />
                </Circle>

            )}
            {isSlideIndicator && (
                <div className="carousel-button-group--slide-indicator-container" style={{ width: SLIDE_INDICATOR_WIDTH }}>
                    <div
                        className="carousel-button-group--slide-indicator-range"
                        style={{
                            width: slideIndicatorRangeWidth,
                            transform: `translateX(${slideIndicatorRangePosition}px)`
                        }}
                    />
                </div>
            )}
            {currentSlide !== (totalItems - slidesToShow) && (
                <Circle
                    ariaLabel="Następna strona"
                    onClick={next}
                    tag="button"
                    color="secondary"
                    background="white"
                    border="secondary"
                    className="carousel-button-group-next"
                >
                    <Icon name="arrow-right" color="secondary" size={18} />
                </Circle>
            )}
        </div>
    );
};

export default CarouselMultiButtonGroup;
